// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3Cwg4","rootCenter":"LoadMoreObserver_rootCenter__13ZT5","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2uQPL"};